import { Component, Shark, Utils } from "shark-mvc";
import { Modal } from "bootstrap";

import tinymce from "tinymce";
import "tinymce/icons/default";
import "tinymce/plugins/advlist";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/code";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/paste";
import "tinymce/plugins/table";
import "tinymce/skins/ui/oxide/skin.css";
import "tinymce/themes/silver";

import templateContent from "./task-modal.html";

import Attachment from "../../models/Attachment";
import Task from "../../models/Task";

import attachmentManager from "../../controllers/attachmentManager";
import taskManager from "../../controllers/taskManager";
import userPermissionManager from "../../controllers/userPermissionManager";
import waitBoxComponent from "../wait-box/waitBoxComponent";

class TaskModalComponent extends Component {
	constructor () {
		super("taskModalComponent");
		this.addTemplate("", templateContent);
	}

	addAttachmentToTaskBtn_clickHandler () {
		const attachmentField = document.querySelector("#attachmentField");

		if (attachmentField) {
			attachmentField.click();
		}
	}

	addTaskBtn_clickHandler () {
		this.createNewTask();
		Shark.render();
		this.open();
	}

	async addTaskToActivityBtn_clickHandler (event, data) {
		const activityGuid = data.guid;

		await this.loadUserPermissionsForActivity(activityGuid);

		this.taskTemplate = {
			activityGuid,
			projectGuid: Shark.$store?.currProject?.guid,
		};

		this.createNewTask();
		Shark.render();
		this.open();
	}

	afterLoad () {
		// if (!this.modal) {
		// }
		const modalNode = document.querySelector("#taskModal");

		if (modalNode) {
			this.modal = new Modal(modalNode, {
				keyboard: false
			});
		}

		tinymce.remove("textarea#taskModalDescriptionField");

		tinymce.init({
			content_style: `			
			p {
    			margin-bottom: .3em;
			}

			span.linkedToBox {
				background: #ee7614;
				border-radius: 5px 0 5px 5px;
				color: #ffffff;ù
				/* font-size: 14px; */
				/* line-height: 1em; */
				margin: 0 5px 0 8px;
				padding: 1px 7px;
			}
			
			ul {
    			margin: .3em auto;
			}
			`,
			entity_encoding : "raw",
			init_instance_callback: editor => {
				// console.log({editor});
				this.tinyEditor = editor;
				this.tinyInited = true;

				editor.on("change", () => {
					const { currTask } = Shark.get();

					if (currTask) {
						currTask.set({
							body: this.tinyEditor.getContent(),
						});
					}				
				});
			},
			// lists_indent_on_tab: false,
			plugins: ["advlist", "autoresize", "code", "link", "lists", "paste", "pastetext", "table"],
			selector: "textarea#taskModalDescriptionField",
			setup: editor => {
				editor.on("keydown", async event => {
					if (event.ctrlKey && event.code === "Enter") {
						this.saveAndNew(event);
					}
				});
			},
			toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist",
		});

		document.addEventListener("paste", async (e) => {
			const clipboardItems = typeof navigator?.clipboard?.read === "function" ? await navigator.clipboard.read() : e.clipboardData.files;
			console.log({clipboardItems});

			for (const clipboardItem of clipboardItems) {
				let blob;
				console.log({clipboardItem});
				
				if (clipboardItem.type?.startsWith("image/")) {
					e.preventDefault();

					// For files from `e.clipboardData.files`.
					blob = clipboardItem;
					// Do something with the blob.
					this.appendImage(blob);
				}
				else {
					e.preventDefault();

					// For files from `navigator.clipboard.read()`.
					const imageTypes = clipboardItem.types?.filter(type => type.startsWith("image/"));

					for (const imageType of imageTypes) {
						blob = await clipboardItem.getType(imageType);
						// Do something with the blob.
						this.appendImage(blob);
					}
				}
			}
		});
	}

	// Dave.ToDo: Bisogna refactorare questa roba
	appendImage (blob) {
		const { currActivity, currTask } = Shark.get();

		if (currTask) {
			waitBoxComponent.open();

			const newFile = new File([blob], "clipboard.png");
			
			return attachmentManager.upload({ dataset: { destFolder: `attachments/${currActivity.guid}`, saveName: ""}, files: [newFile]})
			.then(uploadResponse => {
				console.log({uploadResponse});

				let documentList = uploadResponse.data;

				return attachmentManager.save(documentList)
				.then(saveDocumentsResponse => {
					console.log({saveDocumentsResponse});
					// documentList = saveDocumentsResponse.data.map(item => new Document(item.exportedItem));
					const previousValue = currTask.attachmentGuidList;
				
					currTask.set({
						attachmentGuidList: [...previousValue, ...documentList.map(item => item.guid)],
					});

					waitBoxComponent.close();
					Shark.render();
					this.getTaskAttachments(currTask);
					return documentList;
				});
			});
		}
	}

	attachmentField_inputHandler (event) {
		const { /*currActivity,*/ currTask } = Shark.get();

		if (currTask) {
			waitBoxComponent.open();
			
			return attachmentManager.upload(event.target)
			.then(uploadResponse => {
				console.log({uploadResponse});

				let documentList = uploadResponse.data;

				return attachmentManager.save(documentList)
				.then(saveDocumentsResponse => {
					console.log({saveDocumentsResponse});
					// documentList = saveDocumentsResponse.data.map(item => new Document(item.exportedItem));
					const previousValue = currTask.attachmentGuidList;
				
					currTask.set({
						attachmentGuidList: [...previousValue, ...documentList.map(item => item.guid)],
					});

					waitBoxComponent.close();
					Shark.render();
					this.getTaskAttachments(currTask);
					return documentList;
				});
			});
		}
	}
	

	async cancelTask (guid) {
		const selectedTask = Utils.safp(Shark.$store.taskList, "guid", guid);
		const endNotes = prompt("Per favore inserisci una motivazione per l'annullamento:");

		if (selectedTask && endNotes && endNotes.trim() !== "") {
			selectedTask.set({
				endNotes,
			});

			const cancelResponse = await taskManager.close(selectedTask);
			if (cancelResponse.status === "ok") {
				this.close(true);
			}
		}
		else {
			alert("È obbligatoria una motivazione per annullare un task!");
		}
	}

	cancelTaskBtn_clickHandler (event, data) {
		this.cancelTask(data.guid);
	}

	cancelTaskEdits () {
		if (!Shark.$store?.currTask?.isDirty() || confirm("Vuoi davvero annullare le modifiche?")) {
			Shark.$store.currTask.restore();
			this.close();
			// this.taskDetailBoxCollpase.hide();
			// this.createNewTask();
			Shark.render();
		}
	}

	close (reloadPage = false) {
		if (reloadPage) {
			this.reloadOpeningPage();
		}

		if (this.modal) {
			this.modal.hide();
			this.set("open", false);
		}
	}

	async closeTask (guid) {
		const selectedTask = Utils.safp(Shark.$store.taskList, "guid", guid);
		const endNotes = prompt("Puoi inserire un commento per la chiusura\n(clicca ok per chiudere senza inserire note):");

		if (selectedTask && endNotes !== null) {
			selectedTask.set({
				endNotes,
			});

			const closeResponse = await taskManager.close(selectedTask);
			if (closeResponse.status === "ok") {
				this.close(true);
			}
		}
	}

	closeTaskBtn_clickHandler (event, data) {
		this.closeTask(data.guid);
	}

	createNewTask () {
		const currTask = new Task({
			activityGuid: Shark.$store?.currActivity?.guid,
			assigneeGuid: "",
			createdByGuid: Shark.$store?.loggedUser?.guid,
			priority: 3,
			projectGuid: Shark.$store?.currActivity?.projectGuid,
			status: 1,
			...this.taskTemplate,
			rnd: Math.random().toString(36),
		});

		this?.tinyEditor?.setContent("");

		Shark.set({
			currTask,
		});

		return currTask;
	}

	deleteAttachment (guid) {
		const { currTask } = Shark.get();

		if (currTask) {
			const newAttachmentList = currTask.__attachmentList.filter(item => item.guid !== guid);
			currTask.set({
				attachmentGuidList: newAttachmentList.map(item => item.guid),
				__attachmentList: newAttachmentList,
			});
			Shark.render();
		}
	}

	deleteAttachmentBtn_clickHandler (event, data) {
		if (confirm(`Vuoi davvero eliminare l'allegato?`)) {
			this.deleteAttachment(data.guid);
		}
	}

	async editTask (guid) {
		const currTask = Utils.safp(Shark.$store.taskList, "guid", guid);

		if (currTask) {
			await this.loadUserPermissionsForActivity(currTask.activityGuid);
			Shark.set({ currTask });
			Shark.render();

			this.tinyEditor.setContent(currTask.body);

			this.getTaskAttachments(currTask);
			// this.taskDetailBoxCollpase.show();
			this.open();
		}
	}

	editTaskBtn_clickHandler (event, data) {
		this.editTask(data.guid);
	}

	async getTaskAttachments (task) {
		const attachmentListResponse = await attachmentManager.getByGuidList(task.attachmentGuidList);
		const attachmentList = Shark.getInstanceList(Attachment, attachmentListResponse.data);

		const { currTask } = Shark.get();

		if (currTask) {
			currTask.set({
				__attachmentList: attachmentList,
			});
			currTask.clean(["__attachmentList"]);
			Shark.render();
		}
	}

	async importMultilpeTaskBtn_clickHandler () {
		const { importTaskSettings, currTask } = Shark.get();

		if (importTaskSettings) {
			const textList = importTaskSettings.rawList.split("\n").map(item => item.trim()).filter(item => item !== "");
			console.log({textList});

			if (textList.length > 0 && confirm(`Stai per importare ${textList.length} task, vuoi davvero proseguire?`)) {
				const taskList = textList.map(item => {
					return new Task({
						activityGuid: currTask.activityGuid,
						assigneeGuid: currTask.assigneeGuid || "",
						body: item.length > 128 ? item : "",
						createdByGuid: Shark.$store?.loggedUser?.guid,
						name: item.slice(0, 128),
						priority: currTask?.priority || 3,
						projectGuid: currTask.projectGuid,
						status: 1,
						// ...this.taskTemplate,
						// rnd: Math.random().toString(36),
					});
				});
				
				console.log({taskList});
				
				await taskManager.saveMulti(taskList);

				importTaskSettings.set({ rawList: "" });
				
				this.reloadOpeningPage();
			}
		}
	}

	init () {
		this.addComponents([waitBoxComponent]);

		const importTaskSettings = Shark.getInstance("__smart__", {
			rawList: "",
		});

		Shark.set({
			currTask: Shark.$store.currTask || null,
			importTaskSettings,
		});
	}

	// Dave: questa c'è anche nella task list, va messo altrove.
	async loadUserPermissionsForActivity (activityGuid) {
		let { currActivity } = Shark.get();

		if (!currActivity && activityGuid) {
			currActivity = Utils.safp(Shark.$store.activityList, "guid", activityGuid);
		}

		const userPermissionResponse = await userPermissionManager.getActiveForUserByActivityGuid(activityGuid);
		console.log({userPermissionResponse});

		if (userPermissionResponse.data.length > 0) {
			const currProjectUserPermissions = userPermissionResponse.data[0];

			Shark.set({
				currProjectUserPermissions,
				loggedUserCanAddTasks: currProjectUserPermissions.hasPermission("addTask"),
				loggedUserCanAssignTasks: currProjectUserPermissions.hasPermission("assignTask"),
				loggedUserCanCancelTask: currProjectUserPermissions.hasPermission("cancelTask"),
				loggedUserCanCloseTasks: currProjectUserPermissions.hasPermission("closeTask"),
				loggedUserCanEditTasks: currProjectUserPermissions.hasPermission("editTask"),
			});
		}
		else{
			Shark.set({
				loggedUserCanAddTasks: currActivity.__userIsOwner,
				loggedUserCanAssignTasks: currActivity.__userIsOwner,
				loggedUserCanCancelTask: currActivity.__userIsOwner,
				loggedUserCanCloseTasks: currActivity.__userIsOwner,
				loggedUserCanEditTasks: currActivity.__userIsOwner,
			});
		}
	}

	open () {
		if (this.modal) {
			this.modal.show();
			this.set("open", true);
		}
	}

	async reloadOpeningPage () {
		if (Shark.activePage.refreshList) {
			// Dave: qusta roba fa schifo, dove sono gli eventi?
			if (Shark.activePage.id == "taskListView") {
				await Shark.activePage.refreshList(Shark.$store?.currActivity?.guid, false);
			}
			else if (Shark.activePage.id == "activityListView") {
				await Shark.activePage.refreshList(Shark.$store?.currProject?.guid);
			}
		}
	}

	async saveAndNew (originalEvent) {
		if (this.savePending) {
			console.trace("Vorrei salvare mentre sto salvando...");
			return;
		}

		this.savePending = true;

		originalEvent?.preventDefault();
		originalEvent?.stopPropagation();
		originalEvent?.stopImmediatePropagation();
		
		waitBoxComponent.open();

		console.log("Save and new: pre saveTask");
		
		await this.saveTask(true);
		console.log("Save and new: post saveTask");
		await this.reloadOpeningPage();
		console.log("Save and new: post reloadOpeningPage");
		
		setTimeout(() => {
			this.createNewTask();
			console.log("Save and new: post createNewTask");
			console.log("Save and new: pre focus");
			document.querySelector("#taskModalNameField")?.focus();
			console.log("Save and new: post focus");
			waitBoxComponent.close();
			console.log("Save and new: post close");
			this.savePending = false;
			console.log("Save and new: post savePending = false");
		}, 200);
	}
	
	async saveTask (preventClosing = false) {
		const { currTask } = Shark.get();

		if (currTask) {
			currTask.set({
				body: this.tinyEditor.getContent(),
			});
	
			const errors = currTask.validate();

			if (errors.length > 0) {
				alert(errors.map(item => item.error).join("\n"));
			}
			else {
				// let taskTemplate;
				if (currTask.guid === "") {
					this.taskTemplate = {
						assigneeGuid: currTask.assigneeGuid,
						priority: currTask.priority,
					};
				}
				else {
					this.taskTemplate = null;
				}
				
				const saveResult = await taskManager.save(currTask);

				Shark.set({
					currTask,
				});
				// .then(() => {
					// this.createNewTask(taskTemplate);
				if (!preventClosing) {
					this.close(true);
				}
				// });
			}
		}
	}

	taskModalNameField_keyupHandler (event) {
		if (event.originalEvent.ctrlKey && event.originalEvent.code === "Enter") {
			this.saveAndNew(event);
		}
	}

	taskModalCloseBtn_clickHandler () {
		this.cancelTaskEdits();
	}
	
	taskModalSaveBtn_clickHandler () {
		this.saveTask();
	}
}

const taskModalComponent = new TaskModalComponent();

Shark.registerComponent(taskModalComponent);

export default taskModalComponent;